import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import Classes from "./InstallPWA.module.scss"
import logoDefault from "../../assets/img/HE-LogoB-200.png";
const {REACT_APP_ENABLE_PROMPT_INSTALL} = process.env


const InstallPWA = () => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [show, setShow] = useState(true);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    const onClick = (evt) => {
        evt.preventDefault();
        if (promptInstall) {
            promptInstall.prompt();
        }
    };

    if(!promptInstall){
        return
    }

    return (
        <>
            {show && REACT_APP_ENABLE_PROMPT_INSTALL==="true" && (
                <Alert
                    variant="warning"
                    className={`${Classes.alertPosition} mb-0 position-fixed fixed-bottom`}
                    onClose={() => setShow(false)}
                    show={show}
                >
                    <div className="d-flex justify-content-between">
                        <b>
                            <span className="me-3">{("High Educational")}</span>
                            { (
                                <i
                                    onClick={onClick}
                                    role="button"
                                    className="bi bi-box-arrow-in-down"
                                ></i>
                            )}
                        </b>
                        <i
                            role="button"
                            onClick={() => setShow(false)}
                            className="bi bi-x-lg"
                        ></i>
                    </div>
                    <div className={"pt-3"}>{("Installa l'app per accedere a tutti i nostri servizi")}</div>
                    <img
                        className={"mt-3 d-none d-sm-block"}
                        src={logoDefault}
                        style={{ maxHeight: "50px" }}
                        alt="Logo"
                    />
                </Alert>
            )}
        </>
    );
};

export default InstallPWA;
